import Button from '@/common/components/Button'
import SelectController from '@/common/components/SelectController'
import { useCompanyUsers } from '@/common/hooks/queries/useCompanyUsers'
import useDebounce from '@/common/hooks/useDebounce'
import { Mapper } from '@/common/services/mapper'
import { UserData } from '@/common/types/users'
import CreateForwardingDirectiveEntryFormStepHeader from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepHeader'
import { checkinEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant'
import { MaintenanceForwardingsCheckinEntryStepOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { CheckinEntryValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { useCreateForwardingsFormStore } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/stores/createForwardingsFormStore'
import { useFormContext, useWatch } from 'react-hook-form'
import { useParams } from 'react-router-dom'

const CheckinEntryAutoEntryPending = () => {
  const { companyId } = useParams()

  const { increaseStep } = useCreateForwardingsFormStore()

  const [searchEstablishmentUser, setSearchEstablishmentUser] = useDebounce('')

  const { control, setValue } = useFormContext<CheckinEntryValidationSchema>()

  const { checkin_entry_attributes: watchCheckinEntryAttributes } = useWatch({
    control,
  })

  const watchResponsible = watchCheckinEntryAttributes?.responsible

  const autoEntryOption = checkinEntryOptions[MaintenanceForwardingsCheckinEntryStepOptions.AutoEntry]

  const { data: clientUsersOptions, isPending: clientUsersIsPending } = useCompanyUsers({
    filters: {
      companyId,
      search: searchEstablishmentUser,
    },
    mapper: Mapper.mapToOptions<UserData>({
      valueFieldName: 'id',
      labelFieldName: 'full_name',
    }),
  })

  return (
    <div className="flex flex-col gap-4">
      <CreateForwardingDirectiveEntryFormStepHeader
        goBackAction={() => {
          setValue('checkin_entry_type', undefined!)
          setValue('checkin_entry_attributes', undefined!)
        }}
        title={autoEntryOption.title}
        description={autoEntryOption.description}
      />

      <div>
        <SelectController
          control={control}
          name="checkin_entry_attributes.responsible"
          label="Usuário responsável pelo transporte/confirmação de retirada"
          options={clientUsersOptions}
          onInputChange={setSearchEstablishmentUser}
          isLoading={clientUsersIsPending}
          isDisabled={clientUsersIsPending}
        />
      </div>

      <div className="flex items-center justify-end">
        <div className="flex items-center gap-2">
          <Button
            variant="error"
            onClick={() => {
              setValue('checkin_entry_type', undefined!)
              setValue('checkin_entry_attributes', undefined!)
            }}
          >
            Cancelar
          </Button>

          <Button disabled={!watchResponsible} onClick={increaseStep}>
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default CheckinEntryAutoEntryPending
